import { Spin } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './PcodeStaticCanvasPreview.css';

interface PcodeStaticCanvasPreviewProps {
    previewUrl: string;
    currentSize: { width: number; height: number };
}

interface PcodeStaticCanvasPreviewState {
    iframeContentLoaded?: boolean;
}

const BLOCK = 'pcode-static-canvas-preview';

// Отличается от PcodeCanvasPreview тем, что имеет статический previewUrl
// на страницу с уже отрисованными pcode данными
// менять эти данные нельзя, можно только запускать анимации с помощью postMessage
// первая анимация запускается сразу по завершению отрисовки
export class PcodeStaticCanvasPreview extends React.PureComponent<
    PcodeStaticCanvasPreviewProps,
    PcodeStaticCanvasPreviewState
> {
    renderNode = React.createRef<HTMLIFrameElement>();
    state = {
        iframeContentLoaded: false
    };

    public onExternalRestartAnimation() {
        if (this.state.iframeContentLoaded) {
            this.restartAnimation();
        }
    }

    render() {
        const { currentSize } = this.props;

        return (
            <div className={Bem.cls(BLOCK)}>
                <div className={Bem.cls(BLOCK, 'spin')}>
                    <Spin size={'s'} progress={!this.state.iframeContentLoaded} />
                </div>
                <iframe
                    className={Bem.cls(BLOCK, 'iframe')}
                    marginHeight={0}
                    marginWidth={0}
                    width={currentSize.width}
                    height={currentSize.height}
                    ref={this.renderNode}
                    src={this.props.previewUrl}
                    onLoad={this.onIframeContentLoad}
                />
            </div>
        );
    }

    private onIframeContentLoad = () => {
        this.restartAnimation();
        this.setState({ iframeContentLoaded: true });
    };

    private restartAnimation = () => {
        const currentIframe = this.renderNode.current;

        if (currentIframe) {
            const { contentWindow } = currentIframe;

            if (contentWindow) {
                setTimeout(() => {
                    contentWindow.postMessage(JSON.stringify({ action: 'pcode:visible' }), '*');
                }, 200);
            }
        }
    };
}
